<template>
  <div id="contenedor-exportar-conceptos-estimados-favoritos">
    <v-card v-if="$apollo.loading">
      <v-container>
        <v-row
          class="fill-height"
          align-content="center"
          justify="center">
          <v-col
            class="text-subtitle-1 text-center"
            cols="12">
            Preparando exportación de conceptos favoritos estimados...
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6">
            </v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-form
      v-else
      ref="exportarConceptosEstimados"
      v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Exportar Conceptos Favoritos Estimados
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <strong class="secondary--text" style="font-size:16px">
              Seleccionar Rango de Fechas
            </strong>
            <custom-date-picker
              v-model="rangoFechas.inicial"
              :rules="[mixReglas.requerido]"
              label="Fecha Inicial">
            </custom-date-picker>
            <custom-date-picker
              v-model="rangoFechas.final"
              :rules="[mixReglas.requerido]"
              label="Fecha Final">
            </custom-date-picker>
          </v-row>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="!formularioValido"
            :loading="estaCargando"
            @click="generarExcelConceptosEstimados">
          </custom-button>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CONTRATOS_EXCEL_CONCEPTOS_ESTIMADOS from '@/graphql/querys/administracion/contratos/contratosExcelConecptosEstimados.gql';
import mixGenerarExcel from '@/helpers/mixGenerarExcel';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelConceptosEstimadosFavoritos',
  mixins: [mixGenerarExcel],
  components: {
    CustomDatePicker,
    CustomButton,
  },
  apollo: {
    contratos: {
      query: CONTRATOS_EXCEL_CONCEPTOS_ESTIMADOS,
    },
  },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      rangoFechas: {
        inicial: null,
        final: null,
      },
      nombreDocumento: 'CONCEPTOS FAVORITOS ESTIMADOS',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      headersColumnas: [
        {
          value: 'NUMERO CONTRATO', nombreColumna: 'numeroContrato', orden: 1,
        },
        {
          value: 'OBJETO', nombreColumna: 'objeto', orden: 2,
        },
        {
          value: 'CONTRATISTA', nombreColumna: 'contratista', orden: 3,
        },
        {
          value: 'NUM.ESTIM.', nombreColumna: 'numEstimacion', orden: 4,
        },
        {
          value: 'FEC.FIN. ESTIM.', nombreColumna: 'fechaFinEstimacion', orden: 5,
        },
        {
          value: 'SUBPARTIDA', nombreColumna: 'subPartida', orden: 6,
        },
        {
          value: 'CLAVE', nombreColumna: 'claveConcepto', orden: 7,
        },
        {
          value: 'DESCRIPCIÓN', nombreColumna: 'descripcion', orden: 8,
        },
        {
          value: 'UNIDAD', nombreColumna: 'unidad', orden: 9,
        },
        {
          value: 'PRECIO', nombreColumna: 'precio', orden: 10,
        },
        {
          value: 'CANT. ESTIMADA', nombreColumna: 'cantidadEstimada', orden: 11,
        },
        {
          value: 'IMPORTE', nombreColumna: 'importe', orden: 12,
        },
      ],
      noData: [{
        numeroContrato: '',
        objeto: '',
        contratista: '',
        numEstimacion: '',
        fechaFinEstimacion: '',
        subPartida: '',
        claveConcepto: '',
        descripcion: '',
        unidad: '',
        precio: '',
        cantidadEstimada: '',
        importe: '',
      }],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
      },
    };
  },
  methods: {
    async generarExcelConceptosEstimados() {
      const data = this.crearExcelObras;
      await this.mixGenerarExcel(data);
    },
    cerrar() {
      this.$refs.exportarConceptosEstimados.reset();
      this.rangoFechas.inicial = null;
      this.rangoFechas.final = null;
      this.$emit('cerrar');
    },
    getPartidaYSubPartida() {

    },
  },
  computed: {
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
    },
    getConceptosEstimados() {
      if (!this.getContratos) return [];
      const conceptosEstimados = [];
      this.getContratos.forEach((contrato) => {
        if (contrato.estimaciones.length > 0) {
          contrato.estimaciones
            .sort((a, b) => b.numero - a.numero)
            .forEach((estimacion) => {
            // verificar que la fecha final de estimacion este dentro del rango de fecha
              const isBetween = this.$moment(estimacion.fechaAl)
                .isBetween(this.rangoFechas.inicial, this.rangoFechas.final, undefined, '[]');
              if (isBetween) {
                estimacion.conceptos.forEach((concepto) => {
                  if (concepto.concepto.esFavorito) {
                    conceptosEstimados.push({
                      numeroContrato: contrato.numero,
                      objeto: contrato.meta,
                      contratista: contrato.contratista.nombreRazonSocial,
                      numEstimacion: {
                        value: estimacion.numero,
                        estilo: {
                          ...this.estilos.centrado,
                        },
                      },
                      fechaFinEstimacion: {
                        value: this.$moment(estimacion.fechaAl).format('DD/MM/YYYY'),
                        estilo: {
                          ...this.estilos.centrado,
                        },
                      },
                      subPartida: `${concepto.concepto.padre.clave}-${concepto.concepto.padre.concepto}`,
                      claveConcepto: {
                        value: concepto.concepto.clave,
                        estilo: {
                          ...this.estilos.centrado,
                        },
                      },
                      descripcion: concepto.concepto.concepto,
                      unidad: {
                        value: concepto.concepto.unidad,
                        estilo: {
                          ...this.estilos.centrado,
                        },
                      },
                      precio: {
                        value: concepto.concepto.precioUnitario,
                        estilo: {
                          ...this.estilos.dinero,
                        },
                      },
                      cantidadEstimada: {
                        value: concepto.cantidad,
                        estilo: {
                          ...this.estilos.centrado,
                        },
                      },
                      importe: {
                        value: concepto.importe,
                        estilo: {
                          ...this.estilos.dinero,
                        },
                      },
                    });
                  }
                });
              }
            });
        }
      });
      return conceptosEstimados;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.rangoFechas.inicial).format('DD/MM/YYYY');
      const final = this.$moment(this.rangoFechas.final).format('DD/MM/YYYY');
      const datosDocumento = [];
      datosDocumento.push(
        {
          value: `CONCEPTOS FAVORITOS ESTIMADOS DEL ${inicial} AL ${final}`,
          row: 2,
          col: 1,
          estilo: {
            font: {
              size: 16,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 2,
            col: 27,
          },
        },
      );
      return datosDocumento;
    },
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearExcelObras() {
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getConceptosEstimados.length > 0
        ? this.getConceptosEstimados : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },
};
</script>

<style>

</style>
